import React from 'react';
import { Phone, MapPin, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="bg-gray-900/95 backdrop-blur-sm border-b border-gray-700 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        {/* Top contact bar */}
        <div className="flex justify-between items-center py-2 text-sm text-gray-300 border-b border-gray-700">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-1">
              <Phone size={14} />
              <span>06 69 47 52 16</span>
            </div>
            <div className="flex items-center space-x-1">
              <MessageCircle size={14} />
              <a 
                href="https://wa.me/33669475216" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-green-400 transition-colors"
              >
                WhatsApp
              </a>
            </div>
          </div>
          <div className="flex items-center space-x-1">
            <MapPin size={14} />
            <span>Fontainebleau</span>
          </div>
        </div>
        
        {/* Main navigation */}
        <nav className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-gray-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">M</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">VTC Fontainebleau</h1>
              <p className="text-sm text-gray-300">Transport avec Chauffeur</p>
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-blue-400 transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('avantages')}
              className="text-gray-300 hover:text-blue-400 transition-colors"
            >
              Avantages
            </button>
            <Button 
              onClick={() => scrollToSection('devis')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2"
            >
              Demander un Devis
            </Button>
          </div>
        </nav>
      </div>
    </header>
  );
};